const handleBackgroundImageStyleChange = (editor, component) => {
    editor.getSelected().removeClass("backgroundCover backgroundW100 backgroundWH100 bgNoRepeat bgRepeat bgRepeatX bgRepeatY bgRepeatXTop bgRepeatXBottom");
    editor.getSelected().addClass(component.changed.backgroundImageStyle);
};

export default handleBackgroundImageStyleChange;